import React, {useMemo} from "react";
import axios from "axios";
import { ErrorPopup } from "../ErrorPopup/ErrorPopup";
import NewStudentModal from "../NewStudentModal/NewStudentModal";
import SearchHeader from '../SearchHeader/SearchHeader'
import  {FilterTypeId}  from "../SearchHeader/filters-type";
import { baseUrl } from "../assets/Animations";
import "./student-database.css";
import '../StudentModal/student-modal.css'
import {createEllipses} from "../utilityFunctions";

import { gql, useMutation } from "@apollo/client";
import MissingStudentRatePopup from "./MissingStudentRatePopup/MissingStudentRatePopup";
import CheckBox from "../DanitComponents/Inputs/Checkbox";
import SimpleNotification from "../DanitComponents/Notifications/SimpleNotification";
import { MdContentCopy, MdFolderCopy } from "react-icons/md";
import MassEmailPopup from "./MassEmailPopup/MassEmailPopup";
import { format } from "date-fns";
import { getRequestHeaders } from "../api";
//import { setContext } from '@apollo/client/link/context';

const statusStyles = (status) => {
  if (status === "Active") {
    return { color: "#14B8A6", backgroundColor: "#CCFBF1" };
  } else if (status === "Being Onboarded") {
    return { color: "#3B82F6", backgroundColor: "#DBEAFE" };
  } else if (status === "Waitlist") {
    return { color: "#F59E0B", backgroundColor: "#FEF3C7" };
  } else if (status === "Taking a Break") {
    return { color: "#D946EF", backgroundColor: "#FAE8FF" };
  } else if (status === "Summer Break") {
    return { color: "orange", backgroundColor: "#FEEBC8" };
  } else if (status === "Follow Up") {
    return { color: "red" };
  } else if (status === "Scholarship") {
    return { color: "red" };
  } else if (status === "Needs New Teacher") {
    return { color: "red" };
  } else if (status === "Left the School") {
    return { color: "#EF4444", backgroundColor: "#FEE2E2" };
  } else if (status === "Left For Now") {
    return { color: "#EF4444", backgroundColor: "#FEE2E2" };
  } else if (status === "Left - Permanently") {
    return { color: "#EF4444", backgroundColor: "#FEE2E2" };
  } else if (status === "Inquired") {
    return { color: "#EF4444", backgroundColor: "#FEE2E2" };
  } else if (status === "Out of Range") {
    return { color: "#EF4444", backgroundColor: "#FEE2E2" };
  } else {
    return { color: "black" };
  }
}

const statusOptions = [
  {id: "Active", label: "Active"},
  {id: "Being Onboarded", label: "Being Onboarded"},
  {id: "Waitlist", label: "Waitlist"},
  {id: "Taking a Break", label: "Taking a Break"},
  {id: "Summer Break", label: "Summer Break"},
  {id: "Follow Up", label: "Follow Up"},
  {id: "Scholarship", label: "Scholarship"},
  {id: "Needs New Teacher", label: "Needs New Teacher"},
  {id: "Left the School", label: "Left the School"},
  {id: "Left For Now", label: "Left For Now"},
  {id: "Left - Permanently", label: "Left - Permanently"},
  {id: "Inquired", label: "Inquired"},
  {id: "Out of Range", label: "Out of Range"},
]

const StudentDatabase = (props) => {
  //const [newDisplayedFamilies, setDisplayedFamilies] = React.useState([]);
  const [newDisplayedFamilies, setNewDisplayedFamilies] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [newStudent, setNewStudent] = React.useState(false);
  const [nameQuery, setNameQuery] = React.useState("");
  const [schoolQuery, setSchoolQuery] = React.useState("");
  const [teachers, setTeachers] = React.useState([]);
  const [instruments, setInstruments] = React.useState([]);
  const [schools, setSchools] = React.useState([]);
  const [error, setError] = React.useState(false);
  const [totals, setTotals] = React.useState({ MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0 });
  const [closingModal, setClosingModal] = React.useState(false);
  const [missingRatesPopup, setMissingRatesPopup] = React.useState(false);
  const [instrumentTotals, setInstrumentTotals] = React.useState({});
  const [totalInst, setTotalInst] = React.useState(0);
  const [filterState, setFilterState] = React.useState({});
  const [copyNotification, setCopyNotification] = React.useState(false);
  const [checkedBoxes, setCheckedBoxes] = React.useState(0);
  const [massEmailPopup, setMassEmailPopup] = React.useState(false);
  const [initialFamiliesLoading, setInitialFamiliesLoading] = React.useState(true);
  const [backgroundFamiliesLoading, setBackgroundFamiliesLoading] = React.useState(false);
  const [loadedFamilyCount, setLoadedFamilyCount] = React.useState(0);
  const [simpleNotifaction, setSimpleNotification] = React.useState({
    show: false,
    title: 'How is this?',
    subtitle: 'This is it',
    style: {
        backgroundColor: 'bg-green-100',
        titleColor: 'text-green-800',
        subtitleColor: 'text-green-800'
    },
    approved: true,
    action: function() {
        setSimpleNotification(prev => ({...prev, show: false}));
    }
})

  let CREATE_CUSTOMER = gql`
    mutation ($input: CustomerCreateInput!) {
      customerCreate(input: $input) {
        didSucceed
        inputErrors {
          code
          message
          path
        }
        customer {
          id
          name
          firstName
          lastName
          email
          address {
            addressLine1
            addressLine2
            city
            province {
              code
              name
            }
            country {
              code
              name
            }
            postalCode
          }
          currency {
            code
          }
        }
      }
    }
  `;
  const [createCustomer] = useMutation(CREATE_CUSTOMER);


  const controllerRef = React.useRef(null); // UseRef to keep track of AbortController

  const normalizeFamily = (family) => {
    if (!family || typeof family !== 'object') {
      return null;
    }

    const normalizedStudents = Array.isArray(family.students)
      ? family.students.map((student) => ({
          ...student,
          instrumentList: Array.isArray(student?.instrumentList) ? student.instrumentList : [],
        }))
      : [];

    return {
      ...family,
      students: normalizedStudents,
    };
  };

  const fetchPaginatedFamilies = async (limit, skip) => {
    const response = await axios.get(`${baseUrl}/school-management-paginated?limit=${limit}&skip=${skip}`, getRequestHeaders());
    const responseData = response.data;

    if (Array.isArray(responseData)) {
      return {
        families: responseData.map(normalizeFamily).filter(Boolean),
        hasMore: false
      };
    }

    return {
      families: (responseData.families || []).map(normalizeFamily).filter(Boolean),
      hasMore: Boolean(responseData.hasMore),
    };
  };

  React.useEffect(() => {
    let cancelled = false;

    const fetchAllData = async () => {
      const requestHeaders = getRequestHeaders();

      try {
        setInitialFamiliesLoading(true)
        setBackgroundFamiliesLoading(false)
        setLoadedFamilyCount(0)

        const supportingDataPromise = Promise.all([
          axios.get(`${baseUrl}/initialadminrequest`, requestHeaders),
          axios.get(`${baseUrl}/inst`, requestHeaders),
          axios.get(`${baseUrl}/schools`, requestHeaders),
        ]);

        const firstFamiliesRes = await fetchPaginatedFamilies(9, 0);

        if (cancelled) {
          return;
        }

        let allFamilies = [...firstFamiliesRes.families]
        allFamilies.sort(sortByOnboardingDate)
        props.setStudentDatabase(allFamilies)
        setLoadedFamilyCount(allFamilies.length)
        setInitialFamiliesLoading(false)

        supportingDataPromise
        .then(([teachersRes, instrumentsRes, schoolsRes]) => {
          if (cancelled) {
            return;
          }

          setTeachers(teachersRes.data)
          setInstruments(instrumentsRes.data)
          setSchools(schoolsRes.data)
        })
        .catch((err) => {
          console.error('Error fetching supporting data:', err);
          if (!cancelled) {
            setError(err);
          }
        })

        let hasMore = firstFamiliesRes.hasMore
        let skip = allFamilies.length

        if (hasMore) {
          setBackgroundFamiliesLoading(true)
        }

        while (hasMore && !cancelled) {
          const nextPage = await fetchPaginatedFamilies(100, skip)

          if (!nextPage.families.length) {
            break;
          }

          allFamilies = [...allFamilies, ...nextPage.families]
          allFamilies.sort(sortByOnboardingDate)
          props.setStudentDatabase([...allFamilies])
          setLoadedFamilyCount(allFamilies.length)

          skip += nextPage.families.length
          hasMore = nextPage.hasMore
        }

        if (!cancelled) {
          setBackgroundFamiliesLoading(false)
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        if (!cancelled) {
          setInitialFamiliesLoading(false)
          setBackgroundFamiliesLoading(false)
          setError(err);
        }
      }
    };

    fetchAllData();

    return () => {
      cancelled = true;
    };
  }, [])

  


  const sendFilterRequest = async () => {
    try {
      // const params = new URLSearchParams();
  
      // // Add filters dynamically
      // if (filterState.status) params.append('statuses', filterState.status.join(','));
      // if (filterState.instrument) params.append('instruments', filterState.instrument.join(','));
      // if (filterState.school) params.append('schools', filterState.school.join(','));
      // if (filterState.teachers) params.append('teachers', filterState.teachers.join(','));
  
      // // Send GET request with query params
      // const response = await axios.get(`${baseUrl}/filter-students?${params.toString()}`, getRequestHeaders());
  
      // setNewDisplayedFamilies(response.data);
      const response = await axios.get(`${baseUrl}/school-management`, getRequestHeaders())
      setNewDisplayedFamilies(response.data)
    } catch (error) {
      console.error('Error fetching filtered students:', error.message);
      return null;
    }
  };

  React.useEffect(() => {
    //sendFilterRequest(filterState, setNewDisplayedFamilies, controllerRef);
    wholeFilter()
    // Cleanup function to abort ongoing request when the component unmounts or filterState changes
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [filterState]);

  React.useEffect(() => {
    closingModal
      ? (document.body.style.cursor = "wait")
      : (document.body.style.cursor = "pointer");
  }, [closingModal]);

  React.useEffect(() => {
    if(props.studentModal2023) {
      findAndUpdateFamilyInState(props.studentModal2023)
    }
  }, [props.studentModal2023])

  React.useEffect(() => {
    if (teachers) {
      generateTeacherFilterList();
      generateInstrumentFilterList();
    }
  }, [teachers]);

  React.useEffect(() => {
    if (teachers) {
      generateTeacherFilterList();
    }
    if (props.studentDatabase) {
      wholeFilter();
    }
  }, [schoolQuery]);

  React.useEffect(() => {
    if (props.studentDatabase) {
      wholeFilter();
    }
  }, [filterState, nameQuery]);

  React.useEffect(() => {
    if (props.studentDatabase) {
      generateTotals();
      wholeFilter();
      setTheDropdownDisplayForFamiliesStatus(props.studentDatabase);
      tallyUpStudentsByInstrument(props.studentDatabase);
    }
  }, [props.studentDatabase]);

  const sortByOnboardingDate = (a, b) => {
    if (new Date(a.onboardDate) < new Date(b.onboardDate)) {
      return 1;
    }
    if (new Date(a.onboardDate) > new Date(b.onboardDate)) {
      return -1;
    }
    return 0;
  };

  const createSchoolFilterOptions = (res) => {
    let schoolOptions = [];
      res.forEach(school => {
        schoolOptions.push({ id: school.schoolAbbreviation.toLocaleLowerCase(), label: school.name.split(' ')[0] });
      })

    return schoolOptions
  }

  const createInstrumentFilterOptions = (res) => {
    let instrumentOptions = [];
    res.forEach(instrument => {
      instrumentOptions.push({id: instrument.id, label: instrument.name, group: instrument.instrumentGroup});
    })
    return instrumentOptions
  }

  const createTeacherFilterOptions = (res) => {
    let teacherOptions = [];

    if(filterState.school) { 
      res = res.filter(teacher => {
        return filterState.school.includes(teacher.School.toLowerCase())
      })
    }
    res.forEach(teacher => {
      if(!teacher.IsAdmin) {
        teacherOptions.push({ id: teacher.TeacherID, label: teacher.Name });
      }
    })

    //alphabetize teacher
    teacherOptions.sort((a, b) => {
      if(a.label < b.label) { return -1; }
      if(a.label > b.label) { return 1; }
      return 0;
    })

    return teacherOptions
  }

  const filters = useMemo(
    () => [
      {
        id: "teachers",
        label: "Teachers",
        type: FilterTypeId.Dropdown,
        options: createTeacherFilterOptions(teachers),
      },
      {
        id: "instrument",
        label: "Instrument",
        type: FilterTypeId.Dropdown,
        options: createInstrumentFilterOptions(instruments)},
      {
        id: "status",
        label: "Status",
        type: FilterTypeId.Dropdown,
        options: statusOptions
      },
      props.userData.PermissionLevel !== "manager" && {
        id: "school",
        label: "School",
        type: FilterTypeId.Dropdown,
        options: createSchoolFilterOptions(schools),
      },
    ],
    [teachers, instruments, schools]
  );



  const openStudentModal = (id) => {
    props.setStudentModal2023(id);
  };
  const closeStudentModal = async (id) => {
    //LOOP THROUGH STUDENTS AND MAKE SURE ALL OF THEM HAVE RATES THAT ARE NOT 0
    let missingStudentRates = false;
    for (let i = 0; i < modal.students.length; i++) {
      if (
        modal.students[i].allRates[15] === 0 ||
        modal.students[i].allRates[30] === 0 ||
        modal.students[i].allRates[45] === 0 ||
        modal.students[i].allRates[60] === 0
      ) {
        missingStudentRates = true;
      }
    }
    if (missingStudentRates) {
      setMissingRatesPopup(true);
    } else {
      setClosingModal(true);
      let infoToSend = modal;
      if (modal.familyStatus === "Active") {
        //MAKE A NEW WAVE ID FOR NEW FAMILY
        infoToSend.waveCustomerId = infoToSend.waveCustomerId
          ? infoToSend.waveCustomerId
          : await makeANewWaveClient(modal);
        //---------------------------------
        updateFamilyInfo(infoToSend)
      } else {
        updateFamilyInfo(infoToSend)
      }
    }
  };

  const updateFamilyInfo = (data) => {
    axios.put(`${baseUrl}/school-management-new/${data.familyId}`, data)
    .then((res) => {
      props.getFamiliesToWatch();
      findAndUpdateFamilyInState(res.data);
      setClosingModal(false);
      setModal(false);
      props.closeSideNotesWithAnimation();
    })
    .catch((err) => console.log(err))
  }

  const findAndUpdateFamilyInState = (data) => {
    let newStudentDatabase = props.studentDatabase;
    for(let i = 0; i < newStudentDatabase.length; i++) {
      if(newStudentDatabase[i].familyId === data.familyId) {
        newStudentDatabase[i] = data
      }
    }
    props.setStudentDatabase([...newStudentDatabase])
  }

  const editStudentInfo = (theIndex, key, theChange, id) => {
    let student;
    if (newStudent) {
      student = newStudent;
      if (
        key === "addressLine1" ||
        key === "city" ||
        key === "state" ||
        key === "zipcode" ||
        key === "addressLine2"
      ) {
        student.address[key] = theChange;
      } else if (id === "allRates") {
        student.students[theIndex].allRates[key] = theChange;
      } else if (id === "new-instrument") {
        student.students[theIndex].instrumentList = theChange;
      } else {
        id === "student-info"
          ? (student.students[theIndex][key] = theChange)
          : (student[key] = theChange);
      }
      setNewStudent({ ...student });
    } else {
      student = modal;
      if (
        key === "addressLine1" ||
        key === "city" ||
        key === "state" ||
        key === "zipcode" ||
        key === "addressLine2"
      ) {
        student.address[key] = theChange;
      } else if (id === "allRates") {
        student.students[theIndex].allRates[key] = theChange;
      } else if (id === "new-instrument") {
        student.students[theIndex].instrumentList = theChange;
      } else {
        id === "student-info"
          ? (student.students[theIndex][key] = theChange)
          : (student[key] = theChange);
      }
      setModal({ ...student });
    }
  };
  const wholeFilter = () => {
    let masterList = props.studentDatabase.filter((family) => {
      const selectedSchools = props.userData.PermissionLevel === 'manager' ? ['mma'] : filterState.school;
      const selectedTeachers = filterState.teachers;
      const selectedStatus = filterState.status;
      const selectedInstruments = filterState.instrument;
      const nameFilter = nameQuery.toString().toLowerCase();

      const nameMatch = 
      family.familyName.toString().toLowerCase().includes(nameFilter) || 
      family.students.some(student => student.studentName.toString().toLowerCase().includes(nameFilter)) || 
      family.primaryEmail.toString().toLowerCase().includes(nameFilter) || 
      //remove all spaces and non numbers from phone number

      family.primaryCellphone.replace(/[^0-9]/g, '').toString().toLowerCase().includes(nameFilter) || 
      family.primaryHomePhone.replace(/[^0-9]/g, '').toString().toLowerCase().includes(nameFilter)
      const schoolMatch =
        !selectedSchools ||
        selectedSchools.length === 0 ||
        (family.school && selectedSchools.includes(family.school.toLowerCase()));

      const teacherMatch =
        !selectedTeachers || selectedTeachers.length === 0 ||
        family.students.some(student => selectedTeachers.includes(student.teachersId));

      const statusMatch =
        !selectedStatus || selectedStatus.length === 0 ||
        selectedStatus.includes(family.familyStatus) || family.students.some(student => selectedStatus.includes(student.studentStatus));

      const instrumentMatch =
        !selectedInstruments || selectedInstruments.length === 0 ||
        family.students.some(student => {
          return student.instrumentList.some(instrument => selectedInstruments.includes(instrument.id))
        });

      return schoolMatch && teacherMatch && statusMatch && instrumentMatch && nameMatch;
    });
  
    setNewDisplayedFamilies([...masterList]);
  };

  const setTheDropdownDisplayForFamiliesStatus = (list) => {
    for (let i = 0; i < list.length; i++) {
      if (document.getElementById("status-dropdown-" + list[i].familyId)) {
        document.getElementById("status-dropdown-" + list[i].familyId).value =
          list[i].familyStatus;
      }
    }
  };

  const openNewFamily = () => {
    setNewStudent({
      familyId: Math.random().toString(16).slice(2),
      familyName: "",
      waveCustomerId: "",
      students: [
        {
          studentId: Math.random().toString(16).slice(2),
          studentName: "",
          dob: "",
          instrument: "",
          instrumentList: [],
          teachersId: "",
          lessonLength: 0,
          lessonRate: 0,
          allRates: {15: 26, 30: 49, 45: 64, 60: 79},
          studentStatus: "Being Onboarded",
          studentNotes: "",
        },
      ],
      address: {
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zipcode: 0,
      },
      primaryParentName: "",
      secondaryParentName: "",
      school: "",
      primaryEmail: "",
      secondaryEmail: "",
      primaryCellphone: "",
      secondaryCellphone: "",
      primaryHomePhone: "",
      secondaryHomePhone: "",
      familyStatus: "Being Onboarded",
      familyNotes: "",
      hearOfUs: "",
      onboardDate: new Date(),
      paymentType: "",
      autoPay: false,
      leftReview: false,
      siblingDiscount: false,
      moreAttention: false,
      policiesSigned: false,
      groupLessons: false,
      introLesson: false,
      membership: 0,
      password: "password",
      purchased: [],
    });
  };
  const addAStudent = () => {
    let currentFamily = modal ? modal : newStudent;
    currentFamily.students.push({
      studentId: Math.random().toString(16).slice(2),
      studentName: "",
      dob: "",
      instrument: "",
      instrumentList: [],
      teachersId: "",
      lessonLength: 0,
      lessonRate: 0,
      allRates: { 15: 0, 30: 0, 45: 0, 60: 0 },
      studentStatus: "Being Onboarded",
      studentNotes: "",
    });
    modal
      ? setModal({ ...currentFamily })
      : setNewStudent({ ...currentFamily });
  };

  const makeANewWaveClient = async (theNewStudent) => {
    let businessId;
    let stateCode;
    //if(theNewStudent.familyStatus === "Active") {
    if (theNewStudent.school === "MMA") {
      businessId =
        "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBh";
      stateCode = "US-CO";
    } else if (theNewStudent.school === "LSMA") {
      businessId =
        "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2";
      stateCode = "US-MN";
    } else if (theNewStudent.school === "TMA") {
      businessId =
        "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDky";
      stateCode = "US-MI";
    } else if (theNewStudent.school === "MOR") {
      businessId =
        "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQw";
      stateCode = "US-OR";
    } else if (theNewStudent.school === "PSMA") {
      businessId = "QnVzaW5lc3M6YmY0MjEzYmYtYjEwYi00NmNhLTkyZTAtNjBiNTdmNDNlYzY5";
      stateCode = "US-WA";
    } else if (theNewStudent.school === "DEN") {
      businessId = "QnVzaW5lc3M6OWMwZjUwNGMtODQ1Zi00ZTAzLTg3YjEtZDQzMzgzODhkOTZl";
      stateCode = "US-TX";
    } else if (theNewStudent.school === "TEM") {
      businessId = "QnVzaW5lc3M6NzgxZjM0NjItN2JlNy00ZDcyLTg1YzctOTFjOTc5OGQxYTNh";
      stateCode = "US-AZ";
    } else if (theNewStudent.school === "TUL") {
      businessId = "QnVzaW5lc3M6YTA1MDM4ZmEtZTczZS00MGIwLWEwNzctYTQwNjJkYzJmZjNi";
      stateCode = "US-OK";
    } else {
      alert("Please choose a school!");
      return;
    }
    //}

    let zipCodeString;
    if (theNewStudent.address.zipcode) {
      theNewStudent.address.zipcode.toString() === "0"
        ? (zipCodeString = "")
        : (zipCodeString = theNewStudent.address.zipcode.toString());
    } else {
      theNewStudent.address.zipcode = "0";
    }

    let createCustomerVariables = {
      input: {
        businessId: businessId,
        name: theNewStudent.familyName,
        firstName: theNewStudent.primaryParentName,
        lastName: theNewStudent.familyName,
        email: theNewStudent.primaryEmail,
        address: {
          addressLine1: theNewStudent.address.addressLine1,
          addressLine2: theNewStudent.address.addressLine2,
          city: theNewStudent.address.city,
          postalCode: zipCodeString,
          provinceCode: stateCode,
          countryCode: "US",
        },
        currency: "USD",
      },
    };

    return createCustomer({ variables: createCustomerVariables })
      .then((res) => {
        return res.data.customerCreate.customer.id;
      })
      .catch((err) => {
        setError({
          message: err.networkError.result.errors,
          status: err.networkError.result.errors,
        });
        console.log(err.networkError.result.errors);
        return;
      });
  };

  const addANewFamily = async () => {
    let theNewFamily = newStudent;
    theNewFamily.waveCustomerId = await makeANewWaveClient(newStudent);
    axios.post(`${baseUrl}/school-management`,
      { newStudent: theNewFamily }
    )
    .then((res) => {
      props.setStudentDatabase([...props.studentDatabase, res.data]);
      setNewStudent(false);
    })
    .catch((err) => {
      console.log(err)
    });
  };

  const removeAStudent = (id) => {
    setModal({
      ...modal,
      students: modal.students.filter((student) => student.studentId !== id),
    });
  };

  //CREATES THE DROP DOWN LIST OF TEACHERS
  const generateTeacherFilterList = () => {
    let correctTeacherList = [];
    if (schoolQuery === "") {
      correctTeacherList = teachers;
    } else {
      for (let i = 0; i < teachers.length; i++) {
        if (teachers[i].School === schoolQuery.toLowerCase()) {
          correctTeacherList.push(teachers[i]);
        }
      }
    }
    let filteredTeachers = correctTeacherList;
    let theList = document.getElementById("in-student-db-teacher-filter");
    if (theList) {
      while (theList.hasChildNodes()) {
        theList.removeChild(theList.lastChild);
      }
      let theDefaultOption = document.createElement("option");
      theDefaultOption.value = "";
      theDefaultOption.text = "Teacher";
      theList.appendChild(theDefaultOption);
      for (let i = 0; i < filteredTeachers.length; i++) {
        let option = document.createElement("option");
        option.value = filteredTeachers[i].TeacherID;
        option.text = filteredTeachers[i].Name;
        theList.appendChild(option);
      }
    }
  };

  //CREATE INSTRUMENT FILTER DROPDOWN
  const generateInstrumentFilterList = () => {
    let correctTeacherList = [];
    correctTeacherList = instruments;
    let filteredTeachers = correctTeacherList;
    let theList = document.getElementById("in-student-db-instruments-filter");
    if (theList) {
      while (theList.hasChildNodes()) {
        theList.removeChild(theList.lastChild);
      }
      let theDefaultOption = document.createElement("option");
      theDefaultOption.value = "";
      theDefaultOption.text = "Instrument";
      theList.appendChild(theDefaultOption);
      for (let i = 0; i < filteredTeachers.length; i++) {
        let option = document.createElement("option");
        option.value = filteredTeachers[i].parentInstrument;
        option.text = filteredTeachers[i].name;
        theList.appendChild(option);
      }
    }
  };

  const compare = (a, b) => {
    if (a.familyName < b.familyName) {
      return -1;
    }
    if (a.familyName > b.familyName) {
      return 1;
    }
    return 0;
  };

  const alphabetizeStudents = () => {
    props.setDisplayedFamilies([...newDisplayedFamilies.sort(compare)]);
  };

  const tallyUpStudentsByInstrument = (allStudents) => {
    let instruments = {};
    let total = 0;
    for (let i = 0; i < allStudents.length; i++) {
      const familyStudents = Array.isArray(allStudents[i]?.students) ? allStudents[i].students : [];
      for (let k = 0; k < familyStudents.length; k++) {
        const instrumentList = Array.isArray(familyStudents[k]?.instrumentList) ? familyStudents[k].instrumentList : [];
        for (
          let j = 0;
          j < instrumentList.length;
          j++
        ) {
          total++;
          instruments[
            instrumentList[j].parentInstrument
          ]
            ? instruments[
                instrumentList[j].parentInstrument
              ]++
            : (instruments[
                instrumentList[j].parentInstrument
              ] = 1);
        }
      }
    }
    setTotalInst(total);
    setInstrumentTotals(instruments);
  };

  const calculateInstrumentForFamily = (family) => {
    let instArray = [];
    for(let i = 0; i < family.students.length; i++) {
      if(family.students[i].instrumentList.length > 0) {
        if(!instArray.includes(family.students[i].instrumentList[0].name)) {
          instArray.push(family.students[i].instrumentList[0].name)
        }
      }
    }
    return instArray
  }

  const calculateTeachersForFamily = (family) => {
    let teacherArray = [];
    let foundTeachers = {}
    for(let i = 0; i < family.students.length; i++) {
      if(family.students[i].teachersId) {
        if(!foundTeachers[family.students[i].teachersId]) {
          teacherArray.push(convertTeacherIdIntoTeacherNameAndImage(family.students[i].teachersId))
          foundTeachers[family.students[i].teachersId] = true
        }
      }
    }
    return teacherArray
  }

  const convertTeacherIdIntoTeacherNameAndImage = (teacherId) => {
    for(let i = 0; i < teachers.length; i++) {
      if(teachers[i].TeacherID === teacherId) {
        return {name: teachers[i].Name, image: `https://app.atharo.app/images/${teachers[i].ImageName}`, status: teachers[i].Status}
      }
    }
    return {name: 'Old Teacher', image: `https://app.atharo.app/images/mma.jpg`, status: 'Left School'}
  }

  const generateTotals = () => {
    //SET TOTALS BACK TO 0
    setTotals({ MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA:0 });
    //GENERATE TOTALS
    for (let i = 0; i < props.studentDatabase.length; i++) {
      if (props.studentDatabase[i].familyStatus === "Active") {
        for (let j = 0; j < props.studentDatabase[i].students.length; j++) {
          props.studentDatabase[i].students[j].studentStatus === "Active" &&
            setTotals((prev) => ({
              ...prev,
              [props.studentDatabase[i].school]: prev[props.studentDatabase[i].school] + 1,
            }));
        }
      }
    }
  };

  const selectAllFamilies = async (bool) => {
    if(bool) {
      //setCopyNotification(true)
      let allEmails = ''
      let totalChecked = 0
      for(let i = 0; i < newDisplayedFamilies.length; i++) {
        if(document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`)) {
          document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`).checked = true
          allEmails += newDisplayedFamilies[i].primaryEmail + ', '
          totalChecked++
        }
      }
      //copy emails to clipboard
      setCheckedBoxes(totalChecked)
      await navigator.clipboard.writeText(allEmails)
    } else {
      setCheckedBoxes(0)
      for(let i = 0; i < newDisplayedFamilies.length; i++) {
        if(document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`)){
          document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`).checked = false
        }
      }
    }
  }

  const checkAFamilyBox = (id) => {
    let totalChecked = 0
    for(let i = 0; i < newDisplayedFamilies.length; i++) {
      if(document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`)) {
        if(document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`).checked) {
          totalChecked++
        }
      }
      setCheckedBoxes(totalChecked)
      }
  }

  const copySelectEmails = async () => {
    setCopyNotification(true)
    let allEmails = ''
    for(let i = 0; i < newDisplayedFamilies.length; i++) {
      if(document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`)) {
        if(document.getElementById(`${newDisplayedFamilies[i].familyId}-checkbox`).checked){
          allEmails += newDisplayedFamilies[i].primaryEmail + ', '
        }
      }
    }
    //copy emails to clipboard
    await navigator.clipboard.writeText(allEmails)
  }

  const openMassEmailPopup = () => {
    setMassEmailPopup(true)
  }

  const simpleNotificationStyleObj = {
    
      backgroundColor: 'bg-green-100',
      titleColor: 'text-green-800',
      subtitleColor: 'text-green-800'
  
  }

  const countStudents = (fams) => {
    let count = 0
    for(let i = 0; i < fams.length; i++) {
      count = count + fams[i].students.length
    }
    return count
  }

  const exportCSV = () => {
    downloadCSV(newDisplayedFamilies)
  }

  const convertToCSV = (data) => {
    // Create the CSV headers
    const headers = [
      'familyName',
      'primaryEmail',
      'primaryCellphone',
      'address',
      'students',
      'teacherId',
      'school',
      'Needs New Teacher'
    ];
  
    // Extract the necessary fields and format them
    const csvRows = data.map(item => {
      const address = `${item.address?.addressLine1 || ''} ${item.address?.addressLine2 || ''}, ${item.address?.city || ''}, ${item.address?.state || ''}, ${item.address?.zipcode || ''}`;
      const numberOfStudents = item.students.length;
      const teacherNamesSet = new Set();
      let needsNewTeacher = ''
      item.students.forEach(student => {
        const teacherName = convertTeacherIdIntoTeacherNameAndImage(student.teachersId).name;
        if (teacherName) {
          teacherNamesSet.add(teacherName);
        }
        if(convertTeacherIdIntoTeacherNameAndImage(student.teachersId).status === 'leaving' || convertTeacherIdIntoTeacherNameAndImage(student.teachersId).status === 'Left School') {
          needsNewTeacher = 'YES'
        }
      });
      const teacherNames = Array.from(teacherNamesSet).join(' ');
  
      return [
        JSON.stringify(item.familyName || ''),
        JSON.stringify(item.primaryEmail || ''),
        JSON.stringify(item.primaryCellphone || ''),
        JSON.stringify(address.trim() || ''),
        numberOfStudents,
        JSON.stringify(teacherNames || ''),
        JSON.stringify(item.school || ''),
        JSON.stringify(needsNewTeacher || '')
      ].join(',');
    });
  
    return [headers.join(','), ...csvRows].join('\n');
  }

  const convertToCSVRates = (data) => {
    // Create the CSV headers
    const headers = [
      'familyName',
      'Date Onboarded',
      'Rates (15 | 30 | 45 | 60)',
      'primaryEmail',
      'students',
      'school',
    ];
  
    // Extract the necessary fields and format them
    const csvRows = data.map(item => {
      const numberOfStudents = item.students.length;
      const teacherNamesSet = new Set();
      item.students.forEach(student => {
        const teacherName = convertTeacherIdIntoTeacherNameAndImage(student.teachersId).name;
        if (teacherName) {
          teacherNamesSet.add(teacherName);
        }
      });
      const rates = `$${item.students[0].allRates[15]} | $${item.students[0].allRates[30]} | $${item.students[0].allRates[45]} | $${item.students[0].allRates[60]}`;
  
      return [
        JSON.stringify(item.familyName || ''),
        JSON.stringify(format(new Date(item.onboardDate), 'MMM dd yyyy') || ''),
        JSON.stringify(rates || ''),
        JSON.stringify(item.primaryEmail || ''),
        numberOfStudents,
        JSON.stringify(item.school || ''),
      ].join(',');
    });
  
    return [headers.join(','), ...csvRows].join('\n');
  }


  const downloadCSV = (data, filename = 'data.csv') => {
    const csvData = convertToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
  
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
  
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const findAllActiveStudentsWithAllRatesLessThan = (rate) => {
    let students = []
    for(let i = 0; i < newDisplayedFamilies.length; i++) {
      for(let j = 0; j < newDisplayedFamilies[i].students.length; j++) {
        if((newDisplayedFamilies[i].students[j].allRates[30] < rate && newDisplayedFamilies[i].familyStatus === 'Active') || (newDisplayedFamilies[i].students[j].allRates[30] < rate && newDisplayedFamilies[i].students[j].studentStatus === 'Active')) {
          students.push(newDisplayedFamilies[i])
        }
      }
    }
    downloadCSV(students)
    //convertToCSVRates(students)
    //return students
  }
  

  return (
    <div className="student-database">
      <SimpleNotification show={copyNotification} action={setCopyNotification} style={simpleNotificationStyleObj} title={`Emails copied to clipboard.`} />
      <SimpleNotification title={simpleNotifaction.title} subtitle={simpleNotifaction.subtitle} action={simpleNotifaction.action} show={simpleNotifaction.show} style={simpleNotifaction.style} approved={simpleNotifaction.approved} />
      {massEmailPopup && <MassEmailPopup 
        statusOptions={statusOptions} 
        schools={createSchoolFilterOptions(schools)} 
        students={props.studentDatabase}
        teachers={teachers}
        setMassEmailPopup={setMassEmailPopup}
        setSimpleNotification={setSimpleNotification}
        simpleNotifaction={simpleNotifaction}
        />}
      <SearchHeader
        title="Student Database"
        cta="New Family"
        cta2="Create Mass Email"
        cta3="Export .CSV"
        onChangeQuery={(string) => setNameQuery(string)}
        onChangeFilters={(filterState) => setFilterState(filterState)}
        onClickCta={openNewFamily}
        onClickCta2={openMassEmailPopup}
        onClickCta3={exportCSV}
        filters={filters}
        clearAll={true}
        userData={props.userData}
      />
      {initialFamiliesLoading && (
        <div className="student-database__loading-panel">
          <div className="student-database__loading-card">
            <div className="student-database__loading-spinner" />
            <div className="student-database__loading-title">Loading families</div>
            <div className="student-database__loading-subtitle">Pulling in the first set of families for the database.</div>
          </div>
        </div>
      )}
      {closingModal && (
        <div className="cover-up-everything-to-stop-double-click"></div>
      )}
      {checkedBoxes > 0 && (
      <div className="student-database__email-copy__area">
        <div className="student-database__email-copy_box">
          <div className="student-database__email-copy_text">{checkedBoxes} Selected</div>
          <div className="student-database__email-copy_icon">
            <MdContentCopy onClick={() => copySelectEmails()} color="#475569" size={15} />
          </div>
        </div>
      </div>
      )}
      <div className="admin-dashboard-box student-db-box">
          {backgroundFamiliesLoading && (
            <div className="student-database__background-loading">
              <div className="student-database__background-loading-spinner" />
              <div className="student-database__background-loading-text">
                Loading more families...
              </div>
              <div className="student-database__background-loading-count">
                {loadedFamilyCount} loaded
              </div>
            </div>
          )}
          <div className="the-table-wrapper">
            <table className="student-table">
              <thead className="student-database__column-titles">
                <tr>
                  <th>
                    <input type="checkbox" className="student-database__checkbox focus:ring-0 focus:ring-transparent " id="select-all-checkbox" onClick={(e) => selectAllFamilies(e.target.checked)} />
                  </th>
                  <th
                  className="student-db-labels family__column"
                    style={{ cursor: "pointer" }}
                    onClick={() => alphabetizeStudents()}
                  >
                    FAMILY ({newDisplayedFamilies.length})
                  </th>
                  <th className="student-db-labels email__column">EMAIL</th>
                  <th className="student-db-labels student-number__column">STUDENTS ({countStudents(newDisplayedFamilies)})</th>
                  <th className="student-db-labels instruments__column">INSTRUMENTS</th>
                  <th className="student-db-labels teacher__column">TEACHERS</th>
                  {props.userData.PermissionLevel !== 'manager' && <th className="student-db-labels school__column">SCHOOL</th>}
                  <th className="student-db-labels status__column">STATUS</th>
                </tr>
              </thead>
              <tbody className="student-database__t-body">
                {newDisplayedFamilies && Array.isArray(newDisplayedFamilies) && newDisplayedFamilies.map((row, index) => {
                  if (row.familyName !== "*autogenerated*") {
                    return (
                      <tr
                        key={row.familyId}
                        className="student-database__each-row"
                        style={index % 2 === 0 ? {backgroundColor: "rgb(248, 250, 252)"} : {backgroundColor: "rgb(255, 255, 255)"}}
                      >
                        <td>
                          <input type="checkbox" className="student-database__checkbox focus:ring-0 " id={`${row.familyId}-checkbox`} onClick={(e) => checkAFamilyBox(e.target.id)} />
                        </td>
                        <td className="student-db__text family-column__row" onClick={() => openStudentModal(row.familyId)}>
                          {row.familyName}
                          {row.moreAttention && (
                            <img
                              alt="millie"
                              src="millie_bobby_brown_alert.jpg"
                              className="mini-bobby-brown-alert"
                            />
                          )}
                        </td>
                        <td className="student-db__text email-column__row" onClick={() => openStudentModal(row.familyId)}>
                          {row.primaryEmail}
                        </td>
                        <td className="student-db__text student-db__student-number" onClick={() => openStudentModal(row.familyId)}>
                          {row.students && row.students.length}
                        </td>
                        <td className="instrument-column__row" onClick={() => openStudentModal(row.familyId)}>
                          {calculateInstrumentForFamily(row).map((instrument, i) => (i < 2 ? <div key={i} className="student-db__inst-chip">{instrument}</div> : <div key={i} className="student-db__inst-chip">+{calculateInstrumentForFamily(row).length - 2}</div>))}
                        </td>
                        <td className="teacher-column__row" onClick={() => openStudentModal(row.familyId)}>
                          {calculateTeachersForFamily(row).map((teacher, i) => (i < 1 ? <div key={i} className="student-db__teacher-chip" style={(teacher.status === 'Left School' || teacher.status === 'leaving') ? {backgroundColor: '#FEE2E2', color: '#F04B4B', border: '1px solid #F04B4B'} : {backgroundColor: 'white'}}><img className="student-db__teacher-image" src={teacher.image} alt="teachers" />{teacher.name && createEllipses(teacher.name, 15)}</div> : <div className="student-db__teacher-chip">+{calculateTeachersForFamily(row).length - 1}</div>) )}
                        </td>
                        {props.userData.PermissionLevel !== 'manager' &&<td className="teacher-school__row" onClick={() => openStudentModal(row.familyId)}>
                          <div className="student-db__text student-db__student-school">{row.school}</div>
                        </td>}
                        <td className="teacher-status__row" onClick={() => openStudentModal(row.familyId)}>
                          <div style={statusStyles(row.familyStatus)} className="student-db__family-status">{row.familyStatus}</div>
                        </td>
                      </tr>
                    );
                  } else {
                    return null;
                  }
                })}
              </tbody>
            </table>
          </div>
      </div>
      {/* {props.userData.PermissionLevel !== "manager" && <div>
              <div className="student-database__school-totals">
        <div className="student-database__each-school-total">
          MMA: {totals["MMA"]}
        </div>
        <div className="student-database__each-school-total">
          LSMA: {totals["LSMA"]}
        </div>
        <div className="student-database__each-school-total">
          TSMA: {totals["TMA"]}
        </div>
        <div className="student-database__each-school-total">
          MOR: {totals["MOR"]}
        </div>
        <div className="student-database__each-school-total">
          PSMA: {totals["PSMA"]}
        </div>
        <div className="student-database__each-school-total">
          TOTAL:{" "}
          {totals["MMA"] + totals["LSMA"] + totals["TMA"] + totals["MOR"] + totals["PSMA"]}
        </div>
      </div>
      <div style={{ width: "80%", margin: "0px 10% 200px 10%" }}>
        {Object.keys(instrumentTotals).map((instrument, i) => (
          <div
            key={i}
            className="student-database__instrument-totals"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "inline-block",
              padding: "5px",
              margin: "5px 10px",
              borderRadius: "10px",
            }}
          >
            <div className="student-database__each-instrument-total">
              {instrument}: {instrumentTotals[instrument]}|
              {Math.round((instrumentTotals[instrument] / totalInst) * 100)}%
            </div>
          </div>
        ))}
      </div></div>} */}

      {missingRatesPopup && (
        <MissingStudentRatePopup setMissingRatesPopup={setMissingRatesPopup} />
      )}
      {newStudent && (
        <NewStudentModal
          key={newStudent.familyId}
          newFamily={newStudent}
          removeAStudent={removeAStudent}
          addAStudent={addAStudent}
          addAnotherNewStudent={addAStudent}
          closeStudentModal={(id) => closeStudentModal(id)}
          setNewStudent={setNewStudent}
          addANewFamily={addANewFamily}
          editStudentInfo={editStudentInfo}
          teachers={teachers}
          userData={props.userData}
        />
      )}
      {error && <ErrorPopup error={error} setError={setError} />}
    </div>
  );
};

export default StudentDatabase;
